import React from "react";
import Menu from "../../components/ui/Menu";
import Navbar from "../../components/ui/Navbar";
import Footer from "../../components/ui/Footer";

function PrivacyPolicy(props) {
  const closeMenuHandler = () => {
    props.setShowMenu(false);
  };
  return (
    <div>
      <div className="menu" onClick={closeMenuHandler}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      <Navbar title="Terms" setShowMenu={props.setShowMenu} />
      <div
        style={{
          padding: "20px",
          paddingTop: "120px",
          paddingBottom: "120px",
          margin: "20px",
          borderRadius: "10px",
        }}
      >
        <h1 style={{ marginBottom: "20px", textAlign: "left" }}>
          Privacy Policy for MyAgentPro
        </h1>
        <p style={{ marginBottom: "10px", textAlign: "left" }}>
          Effective Date: 12th of November, 2024.
        </p>
        <p style={{ textAlign: "left" }}>
          At AgentPro Technology Businesses ("we", "us", "our"), we value your
          privacy and that of your customers. This Privacy Policy explains how
          we collect, use, store, and protect you and your personal information
          when you use our mobile application ("App") MyAgentPro. By using this
          App, you consent to the data practices described in this Privacy
          Policy.
        </p>
        <ol
          style={{
            listStyleType: "decimal",
            marginLeft: "20px",
            textAlign: "left",
          }}
        >
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Information We Collect
            </h2>
            <p style={{ textAlign: "left" }}>
              We may collect the following types of information when you use the
              App:
            </p>
            <ul style={{ marginLeft: "20px", textAlign: "left" }}>
              <li>
                <p style={{ textAlign: "left" }}>
                  Personal Information: This includes data that identifies you
                  personally, such as your name, email address, phone number,
                  and payment information.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  Usage Data: We may collect information about how you use the
                  App, including your device type, operating system, IP address,
                  pages viewed, and other usage statistics.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  Location Data: If enabled, we may collect information about
                  your device’s location.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  Device Information: We collect data about the device you use
                  to access the App, including model, operating system, and
                  other technical details.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  Your Customer’s Personal Data: This includes data that
                  identifies you personally, such as your name, email address,
                  phone number, and payment information.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  Vehicle Registration Data of your Customers: This includes
                  information that identifies the specific vehicle, allowing us
                  to process your requests accurately. This may include the
                  vehicle's registration number, VIN, make, model, and other
                  relevant details.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              How We Use Your Information
            </h2>
            <p style={{ textAlign: "left" }}>
              We use the information we collect for the following purposes:
            </p>
            <ul style={{ marginLeft: "20px", textAlign: "left" }}>
              <li>
                <p style={{ textAlign: "left" }}>
                  To Provide and Improve the App: We use your information to
                  provide the features and services of the App, personalize your
                  experience, and improve the functionality of the App.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  To Communicate with You: We may use your email address or
                  phone number to send you important updates, notifications, or
                  promotional materials related to the App.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  To Process Orders: If applicable, we collect and process
                  orders based on information provided to complete transactions.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  To Analyze and Improve: We use usage and device data to
                  analyze trends, diagnose technical issues, and improve the
                  App’s performance.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  To Protect Against Fraud and Security Issues: We may use your
                  information to prevent fraud, investigate suspicious activity,
                  or address security concerns.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Sharing Your Information
            </h2>
            <p style={{ textAlign: "left" }}>
              We do not sell or rent your personal information to third parties.
              However, we may share your information in the following
              circumstances:
            </p>
            <ul style={{ marginLeft: "20px", textAlign: "left" }}>
              <li>
                <p style={{ textAlign: "left" }}>
                  Service Providers: We may share your data with third-party
                  service providers who help us operate the App, process
                  payments, send notifications, or perform analytics. These
                  service providers are obligated to protect your data and use
                  it solely for the purpose of providing services to us.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  Legal Requirements: We may disclose your information if
                  required to do so by law, in response to legal processes, or
                  to protect our rights, property, or safety, or the rights,
                  property, or safety of others.
                </p>
              </li>
              <li>
                <p style={{ textAlign: "left" }}>
                  Business Transfers: In the event of a merger, acquisition, or
                  sale of all or part of our business, your information may be
                  transferred as part of the transaction.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Data Retention
            </h2>
            <p style={{ textAlign: "left" }}>
              We retain your personal information for as long as necessary to
              fulfill the purposes outlined in this Privacy Policy or as
              required by law. When your data is no longer needed, we will
              securely delete or anonymize it.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Your Choices and Rights
            </h2>
            <p style={{ textAlign: "left" }}>
              Access and Update Your Information: You can access and update your
              personal information within the App settings or by contacting us
              directly.
            </p>
            <p style={{ textAlign: "left" }}>
              Opt-Out of Marketing Communications: You can opt out of receiving
              promotional emails by following the unsubscribe instructions in
              the email or adjusting your notification preferences in the App.
            </p>
            <p style={{ textAlign: "left" }}>
              Location Data: You can disable location tracking in your device
              settings, which will stop the App from collecting your location
              data.
            </p>
            <p style={{ textAlign: "left" }}>
              Data Deletion: You can request the deletion of your personal
              information by contacting us at [contact@company.com]. Please note
              that certain data may need to be retained for legal or operational
              reasons.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Security
            </h2>
            <p style={{ textAlign: "left" }}>
              We take reasonable measures to protect your personal information
              from unauthorized access, alteration, or disclosure. However, no
              method of data transmission or storage is completely secure, and
              we cannot guarantee the absolute security of your information.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Children's Privacy
            </h2>
            <p style={{ textAlign: "left" }}>
              Our App is not intended for use by children under the age of 13.
              We do not knowingly collect personal information from children. If
              you are a parent or guardian and believe we may have collected
              information from a child, please contact us immediately at
              hi@myagentpro.ng, and we will take steps to delete such
              information.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Third-Party Links
            </h2>
            <p style={{ textAlign: "left" }}>
              The App may contain links to third-party websites or services that
              are not operated by us. We are not responsible for the privacy
              practices of those third parties. We encourage you to review the
              privacy policies of any third-party sites or services you visit.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Changes to This Privacy Policy
            </h2>
            <p style={{ textAlign: "left" }}>
              We may update this Privacy Policy from time to time to reflect
              changes in our practices or for other operational, legal, or
              regulatory reasons. When we update the policy, we will revise the
              "Effective Date" at the top of the page. We encourage you to
              periodically review this Privacy Policy for any updates.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Contact Us
            </h2>
            <p style={{ textAlign: "left" }}>
              If you have any questions about this Privacy Policy or how we
              handle your personal information, please contact us at:
            </p>
            <p style={{ textAlign: "left" }}>AgentPro Technology Businesses</p>
            <p style={{ textAlign: "left" }}>Email: hi@myagentpro.ng</p>
            <p style={{ textAlign: "left" }}>Phone: 02018891876</p>
            <p style={{ textAlign: "left" }}>
              Address: The Philippi Centre, Oluwalogbon House, Plot A, Obafemi
              Awolowo Way, Before Testing Ground Bus-Stop, Alausa, Ikeja Lagos.
            </p>
          </li>
        </ol>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
